export default {
  toasted: {},
  isLoading: true,
  referenceMarketRate: null,
  isSetMarketRate: null,
};
